module.exports = __webpack_public_path__ + "img/career-discovery.8bbaf04f.jpg";